export const LANDING = "/";
export const SIGN_IN = "/signin";
export const HOME = "/home";



// WEBPACK FOOTER //
// ./src/constants/routes.ts